import { useQuery } from "@tanstack/react-query";
import type { DashboardSummary } from "@apartos/contracts";
import { api } from "../lib/api";
import { ApartmentModal } from "./ApartmentModal";
import { BookingModal } from "./BookingModal";
import { HousekeepingModal } from "./HousekeepingModal";
import { PaymentModal } from "./PaymentModal";
import { RoomServiceTaskModal } from "./RoomServiceTaskModal";
import { TaskDetailModal } from "./TaskDetailModal";

type AttentionTask = DashboardSummary["attention"][number];

export function EntityModalHost({ task, onClose, onOpenSection }: { task: AttentionTask; onClose: () => void; onOpenSection: (path: string) => void }) {
  const target = task.target;
  const bookings = useQuery({ queryKey: ["bookings"], queryFn: api.bookings, enabled: target?.entityType === "booking" });
  const apartments = useQuery({ queryKey: ["apartments"], queryFn: api.apartments, enabled: target?.entityType === "apartment" });
  const housekeeping = useQuery({ queryKey: ["housekeeping"], queryFn: api.housekeeping, enabled: target?.entityType === "housekeeping" });
  const roomService = useQuery({ queryKey: ["room-service"], queryFn: api.roomService, enabled: target?.entityType === "room_service" });

  if (target?.entityType === "booking") {
    const booking = bookings.data?.find((item) => item.id === target.entityId);
    if (booking) return <BookingModal booking={booking} onClose={onClose}/>;
  }
  if (target?.entityType === "payment") return <PaymentModal initialBookingId={target.bookingId} onClose={onClose}/>;
  if (target?.entityType === "apartment") {
    const apartment = apartments.data?.find((item) => item.id === target.entityId);
    if (apartment) return <ApartmentModal apartment={apartment} onClose={onClose}/>;
  }
  if (target?.entityType === "housekeeping") {
    const taskItem = housekeeping.data?.find((item) => item.id === target.entityId);
    if (taskItem) return <HousekeepingModal task={taskItem} onClose={onClose}/>;
  }
  if (target?.entityType === "room_service") {
    const taskItem = roomService.data?.find((item) => item.id === target.entityId);
    if (taskItem) return <RoomServiceTaskModal task={taskItem} onClose={onClose}/>;
  }
  return <TaskDetailModal task={task} onClose={onClose} onOpenSection={onOpenSection}/>;
}
